const redirects = {
   'url1' : { landing_page : 'https://www.sverigeforunhcr.se/', name: "unhcr" },
};

export default redirects